<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-ice-cream-cone`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 2c5.268 0 9.743 3.394 11.357 8.115a8.002 8.002 0 011.775 15.249L26.622 44.28a3 3 0 01-5.244 0l-10.51-18.916a8.002 8.002 0 011.775-15.25C14.257 5.395 18.733 2 24 2zm-8.202 24L24 40.764 32.202 26H15.798zm.63-14.591a8.004 8.004 0 0115.144 0l.77 2.249 2.342.4a4.002 4.002 0 01-.178 7.91l-.25.032H14a4 4 0 01-.683-7.943l2.342-.4.769-2.248z"/></svg>
</template>
<script>

export default {
  name: 'IconIceCreamCone',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
